export default function handleDummyAction() {
    console.warn('Dummy Action');
}
